import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { KeycloakAuthGuard } from 'keycloak-angular';
import { KeycloakService } from '../keycloakService/keycloak.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard extends KeycloakAuthGuard {
    constructor(
        protected override router: Router,
        private keycloakService: KeycloakService
    ) {
        super(router, keycloakService.keycloakAngular);
    }

    isAccessAllowed(route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> {
        return new Promise((resolve, reject) => {
            if (!this.authenticated) {
                this.keycloakService.login();
                return reject(false);
            }

            const milisecondsInSecond = 1000;

            const currentDateInSeconds = new Date().getTime() / milisecondsInSecond;
            const tokenExpirationTimeInSeconds = this.keycloakService.getTokenExpirationTime();

            const shouldRefreshToken =
                (tokenExpirationTimeInSeconds || currentDateInSeconds) -
                currentDateInSeconds < this.keycloakService.sessionRenewalTime;

            if (this.keycloakService.getIsTokenExpired()) {
                this.keycloakService.logout();
            } else if (shouldRefreshToken) {
                this.keycloakService.tryTokenUpdate(() => {
                    resolve(true);
                });
            }

            const requiredRoles = route.data['roles'];
            if (
                requiredRoles &&
                !requiredRoles.every((role: string) => this.roles.includes(role))
            ) {
                // Redirect or show an unauthorized page
                return resolve(this.router.parseUrl('/unauthorized'));
            }

            resolve(true);
        });
    }
}